module.exports = __webpack_public_path__ + "static/MommyKaija-7ffd23e1ca7b2ce9cc346bcb029e90e5.jpg";